import { ClientTokenEffect } from './client-token.effect';

export const effects: any[] = [ClientTokenEffect];

export * from './client-token.effect';
